import Marquee from "react-fast-marquee";

const ITEMS = [
  "Residential",
  "Commercial",
  "Demolition",
  "Yard Waste",
  "Furniture",
  "Appliances",
  "Cleanouts",
  "No Hazmat",
  "No Freon",
];

export const EditorialMarquee = () => (
  <div data-testid="editorial-marquee" className="overflow-hidden border-y border-seam bg-ink py-8">
    <Marquee speed={35} gradient={false} pauseOnHover={false}>
      {ITEMS.map((item) => (
        <span key={item} className="mx-10 flex items-center gap-10">
          <span className="text-outline whitespace-nowrap font-display text-6xl font-black italic uppercase leading-none tracking-tighter md:text-7xl">
            {item}
          </span>
          <span className="block h-3 w-3 -skew-x-12 bg-acid" aria-hidden="true" />
        </span>
      ))}
    </Marquee>
  </div>
);
